<template>
	<div class="prospection-container">
		<a-autocomplete-field :modalForm="ClientForm" v-show="true" allowEdit allowNew autofocus clearable label="Cliente / Tomador" modalWidth="550" placeholder="selecionar cliente" obj="client" ref="aafClient" v-model="getCustomerId" style="width: 0; position: absolute; left: -1000px;">
            <template slot="content" slot-scope="{customer}">
                <v-layout column>
                    <v-list-tile-title style="height: 22px;" v-text="customer.name"></v-list-tile-title>
                    <v-list-tile-sub-title class="py-0">
                        {{customer.federalId}} / Nasc.: {{customer.birth? $moment(customer.birth).format('DD/MM/YYYY'): "Data não definida"}}
                    </v-list-tile-sub-title>
                </v-layout>
            </template>
        </a-autocomplete-field>

		<Header :company="company" :userName="userName" :userAvatar="userAvatar" :userOptions="userOptions" :canSearch="canSearch" :searchClientList="search" />

		<!-- <div class="kanban" v-if="!hasCustomer && !customerList.length"> -->
			<div class="kanban-options" v-if="!hasCustomer && !customerList.length">
				<button class="btn-refresh" :disabled="refreshLoading" v-on:click="getLeads()">
					<p>Atualizar</p>
					<v-progress-circular
						:size="14"
						:width="3"
						color="#0d0b53"
						indeterminate
						v-if="refreshLoading"
					></v-progress-circular>
				</button>
				<div class="kanban-options-filters">
					<button class="btn-refresh" v-on:click="clearFilters" :disabled="refreshLoading">
						<p>Limpar</p>
					</button>
					<div class="filter-container">
						<button class="btn-apply" v-on:click="toggleFilterModal">
							<v-icon>fas fa-filter</v-icon>
							<p>Filtros</p>
						</button>
						<div class="filter-content" v-if="filterModal">
							<div class="filter-content-header">
								<h3>Filtros</h3>
								<v-icon v-on:click="toggleFilterModal">fas fa-times</v-icon>
							</div>
							<div class="input-container">
								<label for="">Produtos</label>
								<select v-model="filters.selectedOffer">
									<option selected :value="null">Todos</option>
									<option :key="offer.id" :value="offer.id" v-for="offer in filtersValues.offers">{{ offer.name }}</option>
								</select>
							</div>
							<div class="input-container">
								<label for="">Status</label>
								<select v-model="filters.selectedOfferLeadStatus">
									<option selected :value="null">Todos</option>
									<optgroup :label="semantic.name" v-for="semantic in filtersValues.offerLeadStatus" :key="semantic.id">
										<option :value="status.id" v-for="status in semantic.status" :key="status.id">{{ status.name }}</option>
									</optgroup>
								</select>
							</div>
							<div class="input-container">
								<label for="">Tag</label>
								<select v-model="filters.selectedTag">
									<option selected :value="null">Todas</option>
									<option :key="tag.id" :value="tag.id" v-for="tag in filtersValues.tags">{{ tag.name }}</option>
								</select>
							</div>
							<div class="input-row">
								<div class="input-container">
									<label for="beginDate">Desde</label>
									<input id="beginDate" type="date" v-model="filters.beginDate">
								</div>
								<div class="input-container">
									<label for="endDate">Até</label>
									<input id="endDate" type="date" v-model="filters.endDate">
								</div>
							</div>
							<button class="btn-apply" v-on:click="applyFilters">Aplicar</button>
						</div>
					</div>
				</div>
			</div>

			<kanban-board :stages="stages" :blocks="blocks" @update-block="updateBlock" v-if="!hasCustomer && !customerList.length">
				<div class="drag-column-header-container" v-for="stage in stages" :slot="stage" :key="stage">
					<h2>{{ stage }}</h2>
				</div>
				<KanbanCard 
					v-for="block in blocks" 
					:slot="block.id" :key="block.id+block.name" 
					:onClick="pickupClient" 
					:lead="block"
				/>
				<div v-for="stage in stages" :key="stage" :slot="`footer-${stage}`">
					<button v-if="!refreshLoading && offers.find(offer => offer.name == stage).count == limit" @click.prevent="showMore(stage)" class="btn-load-more">
						<v-icon>fas fa-chevron-down</v-icon>
						Carregar mais
					</button>
				</div>
			</kanban-board>
		<!-- </div> -->

		<div class="customer-list" v-if="!hasCustomer && customerList.length">
			<div class="customer-list-options">
				<button class="btn-refresh" v-on:click="customerList = []">
					<p>Voltar</p>
				</button>
			</div>
			<div class="customer-list-items">
				<Customer :customer="customer" v-for="customer in customerList" :key="customer.id" :onClick="pickupClient" />
			</div>
		</div>

		<ClientBoard 
			v-if="hasCustomer" :customer="customer" :benefitTypes="benefitTypes" 
			:dropClient="dropMyClients" :refresh="refreshCustomer" 
			:offerLeadStatus="filtersValues.offerLeadStatus" :editClient="editClient" 
			:tags="tags"
		/>
	</div>
</template>

<script>
import Header from '../components/Prospection/Header.vue';
import ClientBoard from '../components/Prospection/ClientBoard.vue';
import KanbanCard from '../components/Prospection/Cards/KanbanCard.vue';
import Customer from '../components/Prospection/Customer.vue';
import ClientForm from '../pages/ClientForm.vue';

export default {
	name: 'Prospection',

	components: { Header, ClientBoard, KanbanCard, Customer },

	data() {
		return {
			ClientForm,

			offers: [],
			limit: 15,

			refreshLoading: false,

			filterModal: false,
			filters: {
				selectedOffer: null,
				selectedOfferLeadStatus: null,
				selectedTag: null,
				beginDate: null,
				endDate: null,
			},

			filtersValues: {
				offers: [],
				offerLeadStatus: [],
				tags: [],
			},

			benefitTypes: null,

			processingCustomer: false,
			searchText: '',

			customer: null,
			customerList: [],
			selectedEnrollment: null,
			tags: [],

			userOptions: [
				{
					icon: 'fullscreen',
					title: 'Tela Cheia',
					routeName: '',
					click: (e) => {
						this.$util.toggleFullScreen();
					}
				},
				{
					icon: 'flaticon-access-key',
					title: 'Alterar minha Senha',
					routeName: '',
					click: (e) => {
						window.getApp.showModal('ChangePin');
					}
				},
				{
					icon: 'fas fa-sign-out-alt',
					title: 'Encerrar / Sair',
					routeName: '',
					click: (e) => {
						window.getApp.$emit('APP_LOGOUT');
					}
				}
			],
		};
	},

	computed: {
		stages() {
			return this.offers.map(offer => offer.name) || [];
		},

		blocks() {
			let blocks = [];

			this.offers.forEach(offer => {
				offer.leads.forEach(lead => {
					blocks.push(lead);
				});
			});

			return blocks;
		},

		canSearch() {
			return Boolean(this.processingCustomer);
		},

		company() {
			return this.$store.state.company.brand;
		},

		userName() {
			return this.$store.state.company.user.name;
		},

		userAvatar() {
			let media;
			let avatar = this.$store.state.company.user.avatar;
			if (avatar) {
				media = this.$config.imageUri(avatar, 'avatar');
			}

			return media;
		},
		
		hasCustomer() {
			return Boolean(this.customer);
		},

		customerEnrollments() {
			if (this.customer && this.customer.jobs) {
				return this.customer.jobs.map(el => el.enrollment);
			}

			return [];
		},
	},

	methods: {
		applyFilters() {
			this.filterModal = false;
			this.getLeads();
		},

		clearFilters() {
			this.filters.selectedOffer = null;
			this.filters.selectedOfferLeadStatus = null;
			this.filters.selectedTag = null;
			this.filters.beginDate = null;
			this.filters.endDate = null;

			this.applyFilters();
		},

		toggleFilterModal() {
			this.filterModal = !this.filterModal;
		},

		getStageId(stage) {
			return this.offersSemantic.find(offer => offer.name === stage).id;
		},

		getLeadById(id) {
			return this.blocks.find(block => block.id == id);
		},

		async getLeads() {
			this.refreshLoading = true;

			try {
				this.offers = await this.$api.dataService.execute('offerLead/getLeads', { 
					offerId: this.filters.selectedOffer, 
					offerLeadStatusId: this.filters.selectedOfferLeadStatus, 
					offerTagId: this.filters.selectedTag, 
					beginDate: this.filters.beginDate,
					endDate: this.filters.endDate,
					limit: this.limit 
				});
			} catch(e) {
				// TODO handle error
			}
			
			this.refreshLoading = false;
		},

		async showMore(stage) {
			try {
				this.offers.find(offer => offer.name == stage).page++;

				let res = await this.$api.dataService.execute('offerLead/showMore', { 
					offerId: this.filters.selectedOffer,
					semanticId: this.offers.find(offer => offer.name == stage).id,
					offerLeadStatusId: this.filters.selectedOfferLeadStatus, 
					offerTagId: this.filters.selectedTag, 
					beginDate: this.filters.beginDate,
					endDate: this.filters.endDate,
					limit: this.limit,
					page: this.offers.find(offer => offer.name == stage).page
				});

				res.leads.forEach(lead => {
					this.offers.find(offer => offer.name == stage).leads.push(lead);
				});
			} catch(e) {
				//
			}
		},

		async updateBlock(offerLeadId, statusName) {
			let statusId = this.offers.find(offer => offer.name == statusName).id;
			try {
				let oldOfferLead = this.getLeadById(offerLeadId);
				let newOfferLead = await this.$api.dataService.execute('offerLead/updateOfferLeadStatus', { offerLeadId, statusId, statusName });

				if (newOfferLead) {
					let index = this.offers.find(offer => offer.id == oldOfferLead.semanticId).leads.findIndex(block => block.id == offerLeadId);
					
					if (index > -1) {
						this.offers.find(offer => offer.id == oldOfferLead.semanticId).leads.splice(index, 1);
						this.offers.find(offer => offer.id == newOfferLead.semanticId).leads.push(newOfferLead);
					}
				}
			} catch(e) {
				// TODO handle error
			}
		},

		async refreshCustomer(customerId) {
			try {
				let customer = await this.$api.dataService.getData('prospection/getCustomer', { forceOpps: false, id: customerId, });

				if (!customer) {
					this.$notifyUser({
						type: 'error',
						message: 'Cliente não encontrado!'
					});
				} else {
					this.customer = customer;
				}
			} catch(e) {
				console.log(e);
				// TODO handle error
			}
		},

		async onSearch(customerId, delay = false, forceOpps = false, withoutReset = false) {
			this.selectedEnrollment = null;
			if (!withoutReset) this.customer = null;

			try {
				if (delay) await this.$util.wait(2500);
				let customer = await this.$api.dataService.getData('prospection/getCustomer', { forceOpps, id: customerId, });

				this.$api.dataService.execute('prospection/campaignLog', { type: 'prospection_consult', clientId: customerId });
				if (!customer) {
					this.$notifyUser({
						type: 'error',
						message: 'Cliente não encontrado!'
					});
				} else {
					this.customer = customer;
				}
			}
			catch (err) {
				this.dropMyClients();
				this.$notifyUser({
					type: 'error',
					message: 'Ocorreu um erro inesperado. Contate o suporte!'
				});
			}
		},

		copyText(text, event) {
			event.preventDefault();
			event.stopPropagation();

			window.Clipboard.copy(text);

			this.$notifyUser({
				message: 'Texto Copiado!'
			});
		},

		async search(searchText) {
			try {
				let clientList = await this.$api.dataService.execute('prospection/getCustomerList', { search: searchText });

				if (clientList) {
					if (!clientList.userExists) {
						this.$notifyUser({
							type: 'error',
							message: 'Nome/CPF/CNPJ/Fone não está cadastrado no sistema.'
						});
					} else if (clientList.userExists && clientList.customerList && clientList.customerList.length == 0) {
						this.$notifyUser({
							type: 'error',
							message: 'Cliente sendo atendido por outro operador!'
						});
					}
				}

				if (clientList && clientList.customerList) {
					if (clientList.customerList.length == 1) {
						await this.pickupClient(clientList.customerList[0].id);
					} else {
						this.customerList = clientList.customerList;
					}
				}
			} catch (err) {
				throw err;
			}
		},

		async pickupClient(customerId) {
			try {
				this.$api.dataService.execute('prospection/pickupClient', { id: customerId });
			} catch (err) {
				throw err;
			}
			this.onSearch(customerId, false, false, true)
		},

		async dropMyClients() {
			this.customer = null;
			this.$api.dataService.execute('prospection/dropMyClients', {});
		},

        editClient() {
			this.$refs.aafClient.editRecord(this.getCustomerId());
		},

        getCustomerId() {
			if (this.customer && !this.customer.raw) {
				return this.customer.id;
			}
			return null;
		},
	},

	async created() {
		this.benefitTypes = await this.$api.dataService.search('benefitType');
		this.filtersValues.tags = this.tags = await this.$api.dataService.execute('offerLead/getTags', {});
		this.filtersValues.offers = await this.$api.dataService.execute('offerLead/getOffers', {});
		this.filtersValues.offerLeadStatus = await this.$api.dataService.execute('offerLead/getOfferLeadStatus', {});

		await this.getLeads();
	}
};
</script>

<style scoped>
html {
	height: 100vh;
	overflow: hidden;
}

p {
	margin: 0;
}
.prospection-container {
	width: 100%;
	height: 100vh;
	background-color: var(--background-color);
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.drag-container {
	max-width: 100%;
	padding: 25px 50px;
	margin: 0;
}

.drag-item.is-moving {
	transform: scale(1.1);
}

.drag-column {
	border-radius: 5px;
	background-color: #FFF;
	box-shadow: 0 5px 20px 0 rgba(0,0,0, 0.15);
	padding: 5px;
}

.drag-column-header-container {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
}

.drag-column-count {
	font-size: 16px;
	font-weight: bold;
	color: #262626;
}

.customer-list {
	padding: 50px;
}

.customer-list-items {
	display: flex;
	flex-direction: column;
	margin-top: 25px;
	gap: 10px;
}

.kanban {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	flex: fit-content;
}

.kanban-options {
	padding: 50px;
	padding-bottom: 0%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: flex-start;
}

.kanban-options-filters {
	display: flex;
	flex-direction: row;
	gap: 10px;
}

select, input[type=date] {
	padding: 10px;
	border-radius: 5px;
	background-color: var(--card-color);
	-moz-appearance: listbox;
	-webkit-appearance: listbox;
}

.filter-content select, input[type=date] {
	background-color: #f5f5f5;
}

.btn-refresh, .btn-load-more, .btn-apply {
	color: var(--primary-color);
	background-color: white;
	padding: 10px 20px;
	font-weight: bold;
	border-radius: 5px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	gap: 5px;
}

.btn-apply {
	width: 100%;
	color: var(--on-primary);
	background-color: var(--primary-color-hover);
}

.btn-apply i {
	color: var(--on-primary);
	font-size: 14px;
}

.btn-refresh > i {
	color: var(--primary-color);
	font-size: 14px;
}

.btn-load-more {
	width: 100%;
	text-align: center;
	background-color: white;
	justify-content: center;
	color: var(--primary-color-hover);
}

.btn-load-more i {
	font-size: 16px;
	color: var(--primary-color-hover);
}

.filter-container {
	position: relative;
}

.filter-content {
	display: flex;
	flex-direction: column;
	position: absolute;
	right: 0;
	margin-top: 10px;
	padding: 15px;
	background-color: var(--card-color);
	box-shadow: 0 2px 50px 0 rgba(0,0,0, 0.15);
	gap: 10px;
	border-radius: 5px;
	z-index: 1000000000;
}

.filter-content h3 {
	font-size: 16px;
	font-weight: bold;
	color: var(--primary-color)
}

.filter-content-header {
	width: 100%;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
}

.filter-content-header i {
	font-size: 16px;
	color: #262626
}

.input-row {
	width: 100%;
	display: flex;
	flex-direction: row;
	gap: 10px;
}

.input-container {
	width: 100%;
	display: flex;
	flex-direction: column;
}

.input-container label {
	font-size: 12px;
	font-weight: bold;
	color: #262626;
	margin-bottom: 3px;
}
</style>


// WEBPACK FOOTER //
// src/pages/Prospection.vue